import React from 'react';
import { Row, Col, Image, Space, Typography, Timeline, Grid } from 'antd';
import Chair from '../../assets/img/chair.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Dates({ content }) {
  const {
    heading = 'Important Dates',
    items = [
      { date: 'July 31, 2024', label: 'Early Bird Payment Deadline' },
      { date: 'September 15, 2024', label: 'Abstract Submission Deadline' },
      { date: 'October 20, 2024', label: 'Regular Payment Deadline' },
      { date: 'October 15, 2024', label: 'Notification of Acceptances' },
      { date: 'October 23, 2024 - October 24, 2024', label: 'Conference' },
      { date: 'November 30, 2024', label: 'Full Paper Submission Deadline' },
    ],
    closingNote =
      "Mark your calendars and join us for an unforgettable experience at WCHSS. Together, let's connect, collaborate, and create a healthier, more inclusive world.",
  } = content || {};

  const { xs } = useBreakpoint()
  return (
    <React.Fragment>
      {
        xs ?
          <Row className='content-body' justify="space-around" align="middle" gutter={[0,32]} style={{ backgroundColor: '#fff' }}>
            <Col span={24} style={{ textAlign: 'center' }}>
              <Text style={{ fontSize: 22, fontWeight: 'bold' }}>{heading}</Text>
            </Col>
            <Col span={24}>
              <Image
                width={'100%'}
                src={Chair}
                preview={false}
                style={{ objectFit: 'cover', float: 'right' }}
              />
            </Col>
            <Col span={24}>
              <Timeline>
                {items.map((item, index) => (
                  <Timeline.Item key={index}>
                    <Space direction='vertical' size={0}>
                      <Text style={{ fontSize: 16, color: '#0D6E49' }}>{item?.date}</Text>
                      <Text style={{ fontSize: 17, fontWeight: 500 }}>{item?.label}</Text>
                    </Space>
                  </Timeline.Item>
                ))}
              </Timeline>
            </Col>
          </Row>
        :
          <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
            <Col span={24} style={{ paddingBottom: 64, textAlign: 'center' }}>
              <Text style={{ fontSize: 30, fontWeight: 'bold' }}>{heading}</Text>
            </Col>
            <Col span={12}>
              <Timeline>
                {items.map((item, index) => (
                  <Timeline.Item key={index}>
                    <Space direction='vertical' size={0}>
                      <Text style={{ fontSize: 16, color: '#0D6E49' }}>{item?.date}</Text>
                      <Text style={{ fontSize: 17, fontWeight: 500 }}>{item?.label}</Text>
                    </Space>
                  </Timeline.Item>
                ))}
              </Timeline>
              <Text italic style={{ fontSize: 16 }}>{closingNote}</Text>
            </Col>
            <Col span={3}></Col>
            <Col span={9}>
              <Image
                width={'100%'}
                src={Chair}
                preview={false}
                style={{ objectFit: 'cover', float: 'right' }}
              />
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Dates